import Vue from 'vue'
import Router from 'vue-router'
import QueryString from 'qs'

import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard'
import ForgotPassword from '@/pages/ForgotPassword'
import ResetPassword from '@/pages/ResetPassword'
import Settings from '@/pages/Settings'
import ChangePassword from '@/pages/ChangePassword'
import NewAccount from '@/pages/NewAccount'
import AccountCreated from '@/pages/AccountCreated'
import PersonalSettings from '@/pages/PersonalSettings'
import Invitation from '@/pages/Invitation'
import PrintCodes from '@/pages/PrintCodes'
import Inbox from '@/pages/Inbox'
import Events from '@/pages/Events'
import Event from '@/pages/Event'
import EventMedia from '@/pages/EventMedia'
import ReportSummary from '@/pages/ReportSummary'
import Report from '@/pages/Report'
import CreateReport from '@/pages/reports/CreateReport'
import RunReport from '@/pages/reports/RunReport'
import NewEvent from '@/pages/NewEvent'
import NewEventStart from '@/pages/NewEventStart'
import NewEventChoose from '@/pages/NewEventChoose'
import NewEventInterstitial from '@/pages/NewEventInterstitial'
import SubmissionComplete from '@/pages/SubmissionComplete'

import store from '@/store'

const Admin = () => import(/* webpackChunkName: "group-admin" */ '@/pages/admin/Admin')
const AdminDashboard = () => import(/* webpackChunkName: "group-admin" */ '@/pages/admin/Dashboard')
const AdminWorkflows = () => import(/* webpackChunkName: "group-admin" */ '@/pages/admin/Workflows')
const AdminWorkflow = () => import(/* webpackChunkName: "group-admin" */ '@/pages/admin/Workflow')
const AdminEditWorkflow = () => import(/* webpackChunkName: "group-admin" */ '@/pages/admin/EditWorkflow')
const AdminCompanies = () => import(/* webpackChunkName: "group-admin" */ '@/pages/admin/Companies')
const AdminCompany = () => import(/* webpackChunkName: "group-admin" */ '@/pages/admin/Company')
const AdminEditCompany = () => import(/* webpackChunkName: "group-admin" */ '@/pages/admin/EditCompany')
const AdminNewCompany = () => import(/* webpackChunkName: "group-admin" */ '@/pages/admin/NewCompany')
const AdminManageCompanyWorkflows = () => import(/* webpackChunkName: "group-admin" */ '@/pages/admin/ManageCompanyWorkflows')
const AdminReports = () => import(/* webpackChunkName: "group-admin" */ '@/pages/admin/Reports')

const ManageDashboard = () => import(/* webpackChunkName: "group-manage" */ '@/pages/manage/Dashboard')
const ManageLog = () => import(/* webpackChunkName: "group-manage" */ '@/pages/manage/Log')
const ManageCompanyWorkflows = () => import(/* webpackChunkName: "group-manage" */ '@/pages/manage/CompanyWorkflows')
const ManageEditWorkflow = () => import(/* webpackChunkName: "group-manage" */ '@/pages/manage/EditWorkflow')
const ManageCompanyAdmins = () => import(/* webpackChunkName: "group-manage" */ '@/pages/manage/CompanyAdmins')
const ManageTeams = () => import(/* webpackChunkName: "group-manage" */ '@/pages/manage/Teams')
const ManageNewTeam = () => import(/* webpackChunkName: "group-manage" */ '@/pages/manage/NewTeam')
const ManageNewUser = () => import(/* webpackChunkName: "group-manage" */ '@/pages/manage/NewUser')
const ManageTeamAdmins = () => import(/* webpackChunkName: "group-manage" */ '@/pages/manage/TeamAdmins')
const ManageTeamMembers = () => import(/* webpackChunkName: "group-manage" */ '@/pages/manage/TeamMembers')
const ManageTeamSettings = () => import(/* webpackChunkName: "group-manage" */ '@/pages/manage/TeamSettings')
const ManageUserSettings = () => import(/* webpackChunkName: "group-manage" */ '@/pages/manage/UserSettings')
const ManageUserTeamAdmins = () => import(/* webpackChunkName: "group-manage" */ '@/pages/manage/UserTeamAdmins')
const ManageUserTeamMemberships = () => import(/* webpackChunkName: "group-manage" */ '@/pages/manage/UserTeamMemberships')

Vue.use(Router)

var router = new Router({
  mode: 'history',
  parseQuery (query) {
    return QueryString.parse(query, { depth: 50 })
  },
  stringifyQuery (query) {
    const result = QueryString.stringify(query, { depth: 50 })
    return result ? `?${result}` : ''
  },
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        title: 'Home',
        authenticated: true
      }
    },
    {
      path: '/q/:version/:originatorTeamIdEncoded/:workflowIdEncoded/:additionalDataEncoded',
      name: 'NewEventLegacy',
      component: NewEventStart,
      meta: {
        title: 'Begin a Workflow',
        authenticated: true
      }
    },
    {
      path: '/qr',
      name: 'NewEventStart',
      component: NewEventStart,
      meta: {
        title: 'Begin a Workflow',
        authenticated: true
      }
    },
    {
      path: '/events/new/choose',
      name: 'NewEventChoose',
      component: NewEventChoose,
      meta: {
        title: 'Begin a Workflow',
        authenticated: true
      }
    },
    {
      path: '/events/new/interstitial',
      name: 'NewEventInterstitial',
      component: NewEventInterstitial,
      meta: {
        title: 'Begin a Workflow',
        authenticated: true
      }
    },
    {
      path: '/events/new/',
      name: 'NewEvent',
      component: NewEvent,
      meta: {
        title: 'Begin a Workflow',
        authenticated: true
      }
    },
    {
      path: '/submission_complete',
      name: 'SubmissionComplete',
      component: SubmissionComplete,
      meta: {
        type: 'Submission Complete',
        authenticated: true
      }
    },
    {
      path: '/session/new',
      name: 'Login',
      component: Login,
      props: {
        oauth: false
      },
      meta: {
        title: 'Log in',
        authenticated: false
      }
    },
    {
      path: '/account/password/forgot',
      name: 'ForgotPassword',
      component: ForgotPassword,
      props: {
        oauth: false
      },
      meta: {
        title: 'Forgot password',
        authenticated: false
      }
    },
    {
      path: '/oauth/login',
      name: 'OauthLogin',
      component: Login,
      props: {
        oauth: true
      },
      meta: {
        title: 'Log in',
        authenticated: false
      }
    },
    {
      path: '/oauth/password/forgot',
      name: 'OauthForgotPassword',
      component: ForgotPassword,
      props: {
        oauth: true
      },
      meta: {
        title: 'Forgot password',
        authenticated: false
      }
    },
    {
      path: '/account/password/:token',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        title: 'Reset password',
        authenticated: false
      }
    },
    {
      path: '/account/new/:token?',
      name: 'NewAccount',
      component: NewAccount,
      meta: {
        title: 'Create Your Account',
        authenticated: false
      }
    },
    {
      path: '/account/created',
      name: 'AccountCreated',
      component: AccountCreated,
      meta: {
        title: 'Account Created',
        authenticated: false
      }
    },
    {
      path: '/print',
      name: 'PrintCodes',
      component: PrintCodes,
      meta: {
        title: 'Print QR Codes',
        authenticated: true
      }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: {
        title: 'Settings',
        authenticated: true
      }
    },
    {
      path: '/settings/password',
      name: 'ChangePassword',
      component: ChangePassword,
      meta: {
        title: 'Change password',
        authenticated: true
      }
    },
    {
      path: '/settings/account',
      name: 'PersonalSettings',
      component: PersonalSettings,
      meta: {
        title: 'Personal settings',
        authenticated: true
      }
    },
    {
      path: '/invitations/:token',
      name: 'Invitation',
      component: Invitation,
      meta: {
        title: 'Invitation to Join',
        authenticated: false
      }
    },
    {
      path: '/events',
      name: 'Events',
      component: Events,
      meta: {
        title: 'Events',
        authenticated: true
      }
    },
    {
      path: '/inbox/:team_id',
      name: 'Inbox',
      component: Inbox,
      meta: {
        title: 'Inbox',
        authenticated: true
      }
    },
    {
      path: '/events/:id',
      name: 'Event Details',
      component: Event,
      props: true,
      meta: {
        title: 'Event',
        authenticated: true
      }
    },
    {
      path: '/events/:id/media/:token',
      name: 'Event Media',
      component: EventMedia,
      props: true,
      meta: {
        title: 'Download Event Media',
        authenticated: false
      }
    },
    {
      path: '/reporting',
      name: 'ReportSummary',
      component: ReportSummary,
      meta: {
        title: 'Reporting',
        authenticated: true
      }
    },
    {
      path: '/reporting/report',
      name: 'Report',
      component: Report,
      meta: {
        title: 'Build a Report',
        authenticated: true
      }
    },
    {
      path: '/reports/new',
      name: 'CreateReport',
      component: CreateReport,
      meta: {
        title: 'Build a Report',
        authenticated: true
      }
    },
    {
      path: '/reports/run',
      name: 'RunReport',
      component: RunReport,
      meta: {
        title: 'Run Your Report',
        authenticated: true
      }
    },
    {
      path: '/admin',
      component: Admin,
      children: [
        { path: '', component: AdminDashboard, name: 'AdminDashboard', meta: { title: 'Admin', authenticated: true } },
        { path: 'workflows', component: AdminWorkflows, name: 'AdminWorkflows', meta: { title: 'Workflow Admin', authenticated: true } },
        { path: 'workflows/:id', component: AdminWorkflow, name: 'AdminWorkflow', props: true, meta: { title: 'Worfklow Admin', authenticated: true } },
        { path: 'workflows/:id/edit', component: AdminEditWorkflow, name: 'AdminEditWorkflow', props: true, meta: { title: 'Worfklow Admin', authenticated: true } },
        { path: 'companies', component: AdminCompanies, name: 'AdminCompanies', props: true, meta: { title: 'Company Admin', authenticated: true } },
        { path: 'companies/new', component: AdminNewCompany, name: 'AdminNewCompany', props: true, meta: { title: 'Company Admin', authenticated: true } },
        { path: 'companies/:id', component: AdminCompany, name: 'AdminCompany', props: true, meta: { title: 'Company Admin', authenticated: true } },
        { path: 'companies/:id/edit', component: AdminEditCompany, name: 'AdminEditCompany', props: true, meta: { title: 'Company Admin', authenticated: true } },
        { path: 'companies/:id/workflows', component: AdminManageCompanyWorkflows, name: 'AdminManageCompanyWorkflows', props: true, meta: { title: 'Company Admin', authenticated: true } },
        { path: 'reports', component: AdminReports, name: 'AdminReports', props: true, meta: { title: 'Report Admin', authenticated: true } }
      ]
    },
    { path: '/manage', component: ManageDashboard, name: 'ManageDashboard', meta: { title: 'Manage Users, Teams & Permissions', authenticated: true } },
    { path: '/manage/log', component: ManageLog, name: 'ManageLog', meta: { title: 'Company Admin Log', authenticated: true } },
    { path: '/manage/company_workflows', component: ManageCompanyWorkflows, name: 'ManageCompanyWorkflows', meta: { title: 'Manage Company Workflows', authenticated: true } },
    { path: '/manage/workflows/:id/edit', component: ManageEditWorkflow, name: 'ManageEditWorkflow', props: true, meta: { title: 'Edit Workflow', authenticated: true } },
    { path: '/manage/company_admins', component: ManageCompanyAdmins, name: 'ManageCompanyAdmins', meta: { title: 'Manage Company Admins', authenticated: true } },
    { path: '/manage/teams', component: ManageTeams, name: 'ManageTeams', meta: { title: 'Manage Teams', authenticated: true } },
    { path: '/manage/teams/new', component: ManageNewTeam, name: 'ManageNewTeam', meta: { title: 'Manage Teams', authenticated: true } },
    { path: '/manage/teams/:id', component: ManageTeamSettings, name: 'ManageTeamSettings', props: true, meta: { title: 'Manage Team Settings', authenticated: true } },
    { path: '/manage/teams/:id/admins', component: ManageTeamAdmins, name: 'ManageTeamAdmins', props: true, meta: { title: 'Manage Team Admins', authenticated: true } },
    { path: '/manage/teams/:id/members', component: ManageTeamMembers, name: 'ManageTeamMembers', props: true, meta: { title: 'Manage Team Members', authenticated: true } },
    { path: '/manage/users/new', component: ManageNewUser, name: 'ManageNewUser', props: true, meta: { title: 'Manage User Settings', authenticated: true } },
    { path: '/manage/users/:id', component: ManageUserSettings, name: 'ManageUserSettings', props: true, meta: { title: 'Manage User Settings', authenticated: true } },
    { path: '/manage/users/:id/team_admins', component: ManageUserTeamAdmins, name: 'ManageUserTeamAdmins', props: true, meta: { title: 'Manage User Settings', authenticated: true } },
    { path: '/manage/users/:id/teams', component: ManageUserTeamMemberships, name: 'ManageUserTeamMemberships', props: true, meta: { title: 'Manage User Settings', authenticated: true } }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.meta.title == null) {
    document.title = 'Vos Voco'
  } else {
    document.title = 'Vos Voco - ' + to.meta.title
  }
  if (to.meta.authenticated) {
    store.dispatch('ensureLoggedIn').then(() => {
      next()
    }).catch((error) => {
      if (error) {
        console.log(error)
      }
      next({ path: '/session/new', query: { return_path: to.path, return_query: to.query } })
    })
  } else {
    store.dispatch('logInIfPossible').then(() => {
      next()
    })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js